import JsonViewer from 'vue-json-viewer'
import { formatProfitLabel, formatTransactionErrorLabel, getShortTransactionLogId } from '@smarttransit/common'

export default {
  name: 'agent-transaction-details-dialog',
  components: {
    JsonViewer
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    transaction: {
      type: Object,
      default: null
    }
  },
  computed: {
    dialogModel: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    typeLabel () {
      const iconData = this.transaction && this.transaction.logTypeIconData
      return (iconData && iconData.label) || 'Transaction'
    },
    statusLabel () {
      return (this.transaction && this.transaction.logStatusLabel) || ''
    },
    conversionRateLabel () {
      return (this.transaction && this.transaction.conversionRatePercentLabel) || ''
    },
    profitLabel () {
      const transaction = this.transaction
      if (!transaction) {
        return ''
      }
      return formatProfitLabel(
        transaction.logType,
        transaction.amount,
        transaction.conversionRatePercent,
        transaction.currencyPrefix || ''
      )
    },
    customerTransactionIdLabel () {
      const referenceId = this.transaction && this.transaction.transactionLogReferenceId
      return referenceId ? getShortTransactionLogId(referenceId) : ''
    },
    errorLabel () {
      return formatTransactionErrorLabel(this.transaction)
    },
    logMetadataValue () {
      const metadata = this.transaction && this.transaction.logMetadata
      if (metadata && typeof metadata === 'object') {
        return metadata
      }
      return {}
    },
    hasAccount () {
      const transaction = this.transaction
      return !!(transaction && (transaction.passengerPhoneNumberLabel || transaction.phoneNumberLabel || transaction.giftCounterpartyLabel))
    },
    hasBalance () {
      const transaction = this.transaction
      return !!(transaction && (transaction.profileBalanceBeforeLabel || transaction.profileBalanceAfterLabel))
    },
    statusHistory () {
      const history = this.transaction && this.transaction.statusHistory
      return history && history.length ? history : []
    }
  },
  methods: {
    closeDialog () {
      this.dialogModel = false
    }
  }
}
